import { io } from 'socket.io-client';
import { getApiUrl } from '../config';

// Derive the socket server root from the API URL (strip the /api path suffix)
const getSocketUrl = () => {
    const apiUrl = getApiUrl();
    if (apiUrl.startsWith('http')) {
        return apiUrl.replace(/\/api\/?$/, '');
    }
    // Relative URL — connect to the same origin
    return window.location.origin;
};

let socket = null;
let currentUserId = null;
const socketListeners = new Set();

const notifySocketListeners = () => {
    socketListeners.forEach((listener) => listener(socket));
};

export const connectSocket = (userId) => {
    if (socket && currentUserId === userId) {
        return socket;
    }
    if (socket) {
        // Stale socket for a different user — tear it down.
        socket.disconnect();
        socket = null;
    }

    currentUserId = userId;
    socket = io(getSocketUrl(), {
        path: '/api/socket.io',
        auth: { userId },
        withCredentials: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 2000,
    });

    notifySocketListeners();
    return socket;
};

export const disconnectSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
    currentUserId = null;
    notifySocketListeners();
};

export const getSocket = () => socket;

// Subscribe to socket-instance changes (created/torn down). Fires when the
// global socket object is replaced so consumers can rebind their listeners.
export const subscribeSocket = (listener) => {
    socketListeners.add(listener);
    return () => socketListeners.delete(listener);
};
